import type { NomineeType, VideoTokenType } from '../types';

import { fetchVideoToken } from './apis';
import { getNomineeVideos, getNomineePhotos } from './nomineeHelper';

export const getVideo = (nominee: NomineeType | undefined, locale: string) => {
  if (!locale) return null;
  const upperLocale = locale.toUpperCase();
  const videos = getNomineeVideos(nominee);
  return videos?.[upperLocale];
};

export const getVideoThumbnailByFormat = (nominee: NomineeType | undefined, locale: string, format: string) => {
  const l10nvideo = getVideo(nominee, locale);
  if (!l10nvideo) return '';
  return l10nvideo?.images?.[format] ?? l10nvideo.imageUrl;
};

export const getVideoStream = async (nominee: NomineeType, locale: string) => {
  const l10nvideo = getVideo(nominee, locale);
  if (!l10nvideo?.id) return '';
  const result = await fetchVideoToken(l10nvideo.id);

  if (!result) return '';

  const masVideo = result.find((v: VideoTokenType) => v.mediaAssetId === l10nvideo.id);

  if (!masVideo || masVideo.status !== 'AVAILABLE') return '';

  return masVideo.hlsStreamUrl;
};

const getPhoto = (nominee: NomineeType | undefined, locale: string) => {
  if (!locale) return null;
  const upperLocale = locale.toUpperCase();
  const photos = getNomineePhotos(nominee);
  return photos?.[upperLocale];
};

export const getPhotoByFormat = (nominee: NomineeType | undefined, locale: string, format: string) => {
  const l10nphoto = getPhoto(nominee, locale);
  if (!l10nphoto) return '';
  return l10nphoto?.images?.[format] ?? l10nphoto.imageUrl;
};
